import { showToast } from '../../helper/ShowToast';
import {
    SEND_MESSAGE_REQUEST,
    SEND_MESSAGE_SUCCESS,
    SEND_MESSAGE_FAIL,
    ADD_CHAT_MESSAGE,
    SET_CHAT_HISTORY,
    CLEAR_CHAT_HISTORY,
    SET_LOADING,
    CHAT_HISTORY_DATA
} from '../constants/amplitudeAITypes';
import axios from "../../axios-config";
import { consumeCredits } from './billing';
import { consumePendingRewardNotifications } from './backgroundProcesses';

// Action Creators
export const sendMessageRequest = () => ({
    type: SEND_MESSAGE_REQUEST
});

export const sendMessageFail = () => ({
    type: SEND_MESSAGE_FAIL
});

export const sendMessageSuccess = (message) => ({
    type: SEND_MESSAGE_SUCCESS,
    payload: {
        sender: 'user',
        text: message
    }
});

export const addChatMessage = (message) => ({
    type: ADD_CHAT_MESSAGE,
    payload: message
});

export const setChatHistory = (messages) => ({
    type: SET_CHAT_HISTORY,
    payload: messages
});

export const clearChatHistory = () => ({
    type: CLEAR_CHAT_HISTORY
});

export const chatHistoryData = (data) => ({
    type: CHAT_HISTORY_DATA,
    history: data
})

const handleError = (error) => {
    const message = error.response?.data?.message || error.message || "Something went wrong";
    showToast("error", message);
};

export const setLoading = (isLoading) => {
    return {
        type: SET_LOADING,
        loading: isLoading
    }
}

// Thunk for handling chat interactions

// export const sendMessage = (toast, message) => {
//     return async (dispatch) => {
//         dispatch(sendMessageRequest());
//         try {
//             dispatch(setLoading(true))
//             const authCode = "Bearer " + localStorage.getItem('authToken');
//             const reqBody = {
//                 message: message
//             };
            
//             // Dispatch user message immediately to show in UI
//             const userMessage = {
//                 sender: "user",
//                 text: message,
//                 _id: `temp-${Date.now()}` // temporary ID
//             };
//             dispatch(addChatMessage(userMessage));
            
//             const response = await axios.post(`/amplitude-ai/v1/chat`, reqBody, {
//                 headers: { Authorization: authCode },
//             });
//             if (response.status === 200) {
//                 const aiMessage = {
//                     sender: "ai",
//                     text: response.data.data.response || "No response from AI"
//                 };
//                 sessionStorage.setItem('chatHistorySelectedDate', 'today');
//                 sessionStorage.setItem('chatHistorySelectedRange', 'Today');
//                 dispatch(getChatHistory('today', () => {}))
//                 dispatch(addChatMessage(aiMessage));
//                 dispatch(consumeCredits(1))
//             }
//         } catch (error) {
//             dispatch(sendMessageFail());
//             handleError(toast, error);
//         } finally {
//             dispatch(setLoading(false))
//         }
//     };
// };

// export const sendMessage = (toast, message) => {
//     return async (dispatch, getState) => {
//         dispatch(sendMessageRequest());
//         try {
//             dispatch(setLoading(true))
//             const authCode = "Bearer " + localStorage.getItem('authToken');
//             const reqBody = {
//                 message: message
//             };
            
//             // Always dispatch user message immediately to show in UI
//             const userMessage = {
//                 sender: "user",
//                 text: message,
//                 _id: `temp-${Date.now()}` // temporary ID
//             };
//             dispatch(addChatMessage(userMessage));
            
//             const response = await axios.post(`/amplitude-ai/v1/chat`, reqBody, {
//                 headers: { Authorization: authCode },
//             });
            
//             if (response.status === 200) {
//                 const aiMessage = {
//                     sender: "ai",
//                     text: response.data.data.response || "No response from AI"
//                 };
                
//                 // Ensure we're on today's view
//                 sessionStorage.setItem('chatHistorySelectedDate', 'today');
//                 sessionStorage.setItem('chatHistorySelectedRange', 'Today');
                
//                 // Fetch today's chat history
//                 dispatch(getChatHistory('today', () => {}))
                
//                 // Add AI response
//                 dispatch(addChatMessage(aiMessage));
//                 dispatch(consumeCredits(1))
//             }
//         } catch (error) {
//             dispatch(sendMessageFail());
//             handleError(toast, error);
//         } finally {
//             dispatch(setLoading(false))
//         }
//     };
// };

export const sendMessage = (toast, message) => {
    return async (dispatch, getState) => {
        dispatch(sendMessageRequest());
        try {
            dispatch(setLoading(true))
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const reqBody = {
                message: message
            };
            
            // Always dispatch user message immediately to show in UI
            const userMessage = {
                sender: "user",
                text: message,
                _id: `temp-${Date.now()}` // temporary ID
            };
            dispatch(addChatMessage(userMessage));
            
            const response = await axios.post(`/amplitude-ai/v1/chat`, reqBody, {
                headers: { Authorization: authCode },
            });
            
            if (response.status === 200) {
                const aiMessage = {
                    sender: "ai",
                    text: response.data.data.response || "No response from AI"
                };
                if (response.data.data?.milestonesReached?.length > 0) {
                    dispatch(consumePendingRewardNotifications(response.data.data.milestonesReached));
                }
                
                // Ensure we're on today's view
                sessionStorage.setItem('chatHistorySelectedDate', 'today');
                sessionStorage.setItem('chatHistorySelectedRange', 'Today');
                
                // Add AI response first
                dispatch(addChatMessage(aiMessage));
                
                // Then fetch today's chat history (this will update the history data but not replace current messages)
                dispatch(getChatHistory('today', null, { silent: true }))
                
                dispatch(consumeCredits(1))
            }
        } catch (error) {
            dispatch(sendMessageFail());
            handleError(error);
        } finally {
            dispatch(setLoading(false))
        }
    };
};

export const getChatHistory = (date, setIsLoading = null, options = {}) => {
    const { silent = false } = options;

    return async (dispatch) => {
        setIsLoading?.(true);
        try {
            const authCode = "Bearer " + localStorage.getItem('authToken');
            const response = await axios.get(`/amplitude-ai/v1/chat/history?date=${date}`, {
                headers: { Authorization: authCode },
            });
            if (response.status === 200) {
                dispatch(chatHistoryData(response.data));
                dispatch(clearChatHistory());
            }
        } catch (error) {
            if (!silent) {
                handleError(error);
            }
        } finally {
            setIsLoading?.(false);
        }
    };
}; 